import { render, staticRenderFns } from "./ModalBasic.vue?vue&type=template&id=0addb216"
import script from "./ModalBasic.vue?vue&type=script&lang=js"
export * from "./ModalBasic.vue?vue&type=script&lang=js"
import style0 from "./ModalBasic.vue?vue&type=style&index=0&id=0addb216&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports